import { useEffect } from 'react';
import { altLoginAutoNav } from '../components/AlmeResponse/AlternateLoginAutoNav';
export function useAltLoginNavigationHook(altLoginAutoNavResponseAction, fromHistory, isLastResponse, appConfig) {
    useEffect(() => {
        if (altLoginAutoNavResponseAction && !fromHistory && isLastResponse) {
            altLoginAutoNav(altLoginAutoNavResponseAction, appConfig);
        }
    }, [altLoginAutoNavResponseAction, appConfig, fromHistory, isLastResponse]);
}
